import React, { Component } from 'react'
import connexion from '../../connexion'
import CoverImage from '../UI/CoverImage'
import { Link } from 'react-router-dom'
import Swipeable from 'react-swipeable'
import picture from '../../img/default.jpg'
import './Pages.css'
import { ChevronRightIcon, ChevronDownIcon, ChevronUpIcon, ArrowRightIcon } from '@heroicons/react/solid'
import SectionActions from '../UI/SectionActions'
import ThemeIcon from '../UI/ThemeIcon'
import Skeleton from '../UI/Skeleton'


class Categories extends Component {
	constructor(props) {
		super(props)
		this._enter_anim = (props.consumeNavBack && props.consumeNavBack()) ? "page-back-in" : "page-slide-in"
		this.state = {
			categories: props.categories,
			pages: props.pages,
			lists: props.lists,
			category: null,
			page: null,
			service: null,
			list: null,
			heights : []
		}
		this.colors = [props.theme.color1, props.theme.color2, props.theme.color3, props.theme.color4]
		this.pageRef = React.createRef()
	}

	componentDidMount() {
		this._scroll_key = this.props.history.location.pathname
		const wrapper = document.getElementById("wrapper")
		if (wrapper)
			wrapper.scroll(0, 0) //ancre l'animation d'entrée en haut
		this.loadCategory()
		this.props.updateShell(null, true, this.props.history.location.pathname)
		if (!this.props.icons)
			this.props.fetchIcons()
		this.props.fetchNotifications()
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.match.params.position !== this.props.match.params.position) {
			const el = this.pageRef.current
			if (el) {
				el.style.animation = 'none'
				void el.offsetHeight // force reflow
				el.style.animation = ''
			}
		}
		if (prevProps.categories !== this.props.categories)
			this.loadCategory()
		if (prevState.category !== this.state.category)
		{
			const category = this.state.category
			let prefix = ""
			for (let i = 0; i < this.props.group.translations.length; i++)
			{
				if (this.props.group.translations[i].lang === this.props.user.lang)
				{
					prefix = this.props.group.translations[i].prefix
					break
				}
			}
			let suffix = ""
			for (let i = 0; i < category.translations.length; i++)
			{
				if (category.translations[i].lang === this.props.user.lang)
				{
					suffix = category.translations[i].suffix
					break
				}
			}
			const pathname = '/' + prefix + '/' + suffix
			const infos = {
				group: this.props.group._id,
				category: category._id,
				type: category.type,
				page: (this.state.page) ? this.state.page._id : null,
				list: (this.state.list) ? this.state.list._id : null
			}
			this.props.updateLogs(pathname, 'Categories', infos)
			setTimeout(() => {
				this._scroll_key = this.props.history.location.pathname
			}, 100)
			setTimeout(() => {
				//restauration après la fin de l'animation d'entrée (300ms), pour ne pas décaler les fixed/absolute pendant le transform
				const wrapper = document.getElementById("wrapper")
				if (wrapper && this.props.getScrollPos)
				{
					const saved = this.props.getScrollPos(this.props.history.location.pathname)
					if (saved > 0)
						wrapper.scroll(0, saved)
				}
			}, 320)
		}
		if (prevProps.pages !== this.props.pages || (prevState.category !== this.state.category && this.state.category.type === "page"))
			this.loadPage()
		if (prevProps.lists !== this.props.lists || (prevState.category !== this.state.category && this.state.category.type === "list"))
			this.loadList()
		if (prevProps.pages !== this.props.pages || prevState.list !== this.state.list)
			this.loadPagesList()
	}

	componentWillUnmount() {
		const wrapper = document.getElementById("wrapper")
		if (wrapper && this.props.saveScrollPos && this._scroll_key)
			this.props.saveScrollPos(this._scroll_key, wrapper.scrollTop)
	}

	_loadPageService = (page) => {
		if (page.service && page.service.service && page.service.service !== "precheckin")
		{
			this.props.fetchServiceByID(page.service.service)
			.then(service => {
				this.setState({ page: page, service: service, mounted: true })
			})
		}
		else
			this.setState({ page: page, mounted: true })
	}

	loadPage = () => {
		const category = this.state.category
		if (category && category.type === "page")
		{
			const pages = this.props.pages
			let page = null
			if (pages)
			{
				for (let i = 0; i < pages.length; i++)
				{
					if (pages[i].category === category._id)
					{
						page = pages[i]
						break
					}
				}
				if (page)
				{
					this._loadPageService(page) //cache d'abord : affichage immédiat, revalidation en arrière-plan
					page.timestamp = (page.edited_time) ? page.edited_time : page.created_time
					this.props.fetchPageCheckUpdate(page)
					.then(fetch_page => {
						if (fetch_page !== 1 && fetch_page !== false)
							this._loadPageService(fetch_page)
						else if (fetch_page === 1 && !page.cover && !page.cover_ext)
						{
							this.props.fetchPageByCategory(category._id)
							.then(page => {
								this._loadPageService(page)
							})
							.catch(err => console.log(err))
						}
					})
					.catch(err => {
						console.log("can not check update page", err)
					})
				}
				else
				{
					this.props.fetchPageByCategory(category._id)
					.then(page => {
						this._loadPageService(page)
					})
					.catch(err => console.log(err))
				}
			}
			else
			{
				this.props.fetchPageByCategory(category._id)
				.then(page => {
					this._loadPageService(page)
				})
				.catch(err => console.log(err))
			}
		}
	}

	loadList = () => {
		const category = this.state.category
		if (category && category.type === "list")
		{
			const lists = this.props.lists
			let list = null
			if (lists)
			{
				for (let i = 0; i < lists.length; i++)
				{
					if (lists[i].category === category._id)
					{
						list = lists[i]
						break
					}
				}
				if (list)
				{
					this.setState({ lists: this.props.lists, list: list }) //cache d'abord, revalidation en arrière-plan
					list.timestamp = (list.edited_time) ? list.edited_time : list.created_time
					this.props.fetchListCheckUpdate(list)
					.then(fetch_list => {
						if (fetch_list !== 1 && fetch_list !== false)
							this.setState({ lists: this.props.lists, list: fetch_list })
						else if (fetch_list === 1 && !list.cover && !list.cover_ext)
						{
							this.props.fetchListByCategory(category._id)
							.then(page => {
								this.setState({ lists: this.props.lists, list: list })
							})
							.catch(err => console.log(err))
						}
					})
					.catch(err => console.log(err))
				}
				else
				{
					this.props.fetchListByCategory(category._id)
					.then(list => {
						this.setState({ lists: this.props.lists, list: list })
					})
					.catch(err => console.log(err))
				}
			}
			else
			{
				this.props.fetchListByCategory(category._id)
				.then(list => {
					this.setState({ lists: this.props.lists, list: list })
				})
				.catch(err => console.log(err))
			}
		}
	}

	loadPagesList = () => {
		const category = this.state.category
		const list = this.state.list
		if (category && category.type === "list" && list)
		{
			const pages = this.state.pages
			let load = []
			if (pages)
			{
				for (let i = 0; i < list.elements.length; i++)
				{
					let match = false
					for (let j = 0; j < pages.length; j++)
					{
						if (list.elements[i].page === pages[j]._id)
						{
							match = true
							break
						}
					}
					if (match === false)
						load.push(list.elements[i].page)
				}
			}
			else
			{
				for (let i = 0; i < list.elements.length; i++)
					load.push(list.elements[i].page)
			}
			if (load.length > 0)
			{
				this.props.fetchPagesByIDList(load)
				.then(pages => {
					this.setState({ pages: pages })
				})
				.catch(err => console.log(err))
			}
		}
	}

	loadCategory = () => {
		const position = this.props.match.params.position
		const group = this.props.group._id
		const categories = this.props.categories
		let category = null
		if (categories)
		{
			for (let i = 0; i < categories.length; i++)
			{
				let suffix = ""
				for (let j = 0; j < categories[i].translations.length; j++)
				{
					if (categories[i].translations[j].lang === this.props.user.lang)
					{
						suffix = categories[i].translations[j].suffix
						break
					}
				}
				if (categories[i].group === group && suffix === position)
				{
					category = categories[i]
					break
				}
			}
		}
		if (category === null)
		{
			this.props.fetchCategoriesByGroup(group)
			.then(categories => {
				let category = null
				for (let i = 0; i < categories.length; i++)
				{
					let suffix = ""
					for (let j = 0; j < categories[i].translations.length; j++)
					{
						if (categories[i].translations[j].lang === this.props.user.lang)
						{
							suffix = categories[i].translations[j].suffix
							break
						}
					}
					if (categories[i].group === group && suffix === position)
					{
						category = categories[i]
						break
					}
				}
				this.setState({ categories: categories, category: category })
			})
			.catch(err => console.log(err))
		}
		else
			this.setState({ categories: categories, category: category })
	}

	printRubricTile = (category, key) => {
		let name = ""
		let suffix = ""
		for (let i = 0; i < category.translations.length; i++)
		{
			if (category.translations[i].lang === this.props.user.lang)
			{
				name = category.translations[i].name
				suffix = category.translations[i].suffix
				break
			}
		}
		let prefix = ""
		for (let i = 0; i < this.props.group.translations.length; i++)
		{
			if (this.props.group.translations[i].lang === this.props.user.lang)
			{
				prefix = this.props.group.translations[i].prefix
				break
			}
		}
		let prev = null
		const icons = this.props.icons
		for (let i = 0; i < icons.length; i++)
		{
			if (icons[i]._id === category.icon)
			{
				for (let j = 0; j < icons[i].lineal.length; j++)
				{
					if (icons[i].lineal[j].theme === "blank")
					{
						prev = icons[i].lineal[j].icon
						break
					}
				}
				break
			}
		}
		const url = this.props.lang_assets.paths.rubrics + '/' + prefix + '/' + suffix
		//layout selon le réglage de la rubrique
		if (this.props.group.tiles_photo !== true)
		{
			return (
				<Link to={url} key={key}>
					<div className="pressable h-32 rounded-xl flex flex-col justify-between p-3 shadow" style={{ backgroundColor: '#' + this.props.theme.color1 }}>
						{prev ? <img className="w-8 h-8" src={prev} alt="Icône" /> : <span className="w-8 h-8"></span>}
						<p className="text-white font-semibold text-sm leading-tight">{name}</p>
					</div>
				</Link>
			)
		}
		//dans une rubrique photo, la cover est le défaut ; « custom » la remplace par la photo dédiée
		let tile_source = null
		if (category.tile_mode === "custom" && category.has_tile_image)
			tile_source = "custom"
		else if (category.has_cover)
			tile_source = "cover"
		const tile_photo = (tile_source !== null)
		let visual_style = { backgroundColor: '#' + this.props.theme.color1 }
		if (tile_photo)
		{
			const cover_url = connexion.connect.url + 'webapp/categories/cover?category=' + category._id + ((tile_source === "custom") ? '&source=custom' : '')
			visual_style = { backgroundImage: 'url(' + cover_url + ')' }
		}
		return (
			<Link to={url} key={key}>
				<div className="pressable">
					<div className="h-32 rounded-xl shadow overflow-hidden flex items-center justify-center bg-cover bg-center" style={visual_style}>
						{(!tile_photo && prev) ? <img className="w-8 h-8" src={prev} alt="Icône" /> : null}
					</div>
					<p className="mt-2 mx-0.5 text-gray-900 font-semibold text-xs leading-snug">{name}</p>
				</div>
			</Link>
		)
	}

	//mélange une couleur hexadécimale vers une cible (blanc pour pastel, noir pour le texte)
	mixColor = (hex, target, ratio) => {
		const clean = hex.replace('#', '')
		let mixed = '#'
		for (let i = 0; i < 3; i++)
		{
			const from = parseInt(clean.substr(i * 2, 2), 16)
			const to = parseInt(target.substr(i * 2, 2), 16)
			mixed += Math.round(from + (to - from) * ratio).toString(16).padStart(2, '0')
		}
		return mixed
	}

	printContent = (key, color, text, icon, page) => {
		let url = null
		let has_cover = false
		for (let i = 0; i < this.state.pages.length; i++)
		{
			if (page === this.state.pages[i]._id)
			{
				has_cover = (this.state.pages[i].has_cover === true || this.state.pages[i].cover || this.state.pages[i].cover_ext) ? true : false
				url = this.props.lang_assets.paths.pages + '/'
				for (let j = 0; j < this.state.pages[i].translations.length; j++)
				{
					if (this.state.pages[i].translations[j].lang === this.props.user.lang)
					{
						url += this.state.pages[i].translations[j].url
						break
					}
				}
				break
			}
		}
		let iconDoc = null
		const icons = this.props.icons
		for (let i = 0; i < icons.length; i++)
		{
			if (icons[i]._id === icon)
			{
				iconDoc = icons[i]
				break
			}
		}
		const pastel = this.mixColor(color, 'ffffff', 0.78)
		const dark = this.mixColor(color, '000000', 0.72)
		const cover_url = connexion.connect.url + 'webapp/pages/cover?id=' + page
		const card = (
			<div className="relative w-11/12 mx-auto mt-4 flex flex-row overflow-hidden" style={{ backgroundColor: pastel, borderRadius: '18px', minHeight: '170px', boxShadow: '0 3px 10px rgba(0, 0, 0, 0.08)' }}>
				{
					(has_cover) ? (
						<div className="flex-none" style={{ width: '34%' }}>
							<img className="w-full h-full" style={{ objectFit: 'cover' }} src={cover_url} alt="" />
						</div>
					) : null
				}
				<div className="flex-grow flex flex-col justify-center items-start min-w-0" style={{ padding: '18px 18px 18px 22px' }}>
					{
						(!has_cover && iconDoc) ? (
							<div className="flex-none flex items-center justify-center rounded-full mb-3" style={{ backgroundColor: '#' + color, width: '40px', height: '40px' }}>
								<ThemeIcon icon={iconDoc} type="lineal" color="#FFFFFF" legacyTheme="blank" alt="" style={{ width: '22px', height: '22px' }} />
							</div>
						) : null
					}
					<p className="font-bold" style={{ color: dark, fontSize: '18px', lineHeight: 1.35 }}>{text}</p>
					<div className="flex-none flex items-center justify-center rounded-full bg-white" style={{ marginTop: '16px', width: '44px', height: '44px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)' }}>
						<ArrowRightIcon className="h-5" style={{ color: dark }} />
					</div>
				</div>
			</div>
		)
		if (url === null)
			return (<div key={key}>{card}</div>)
		return (
			<Link to={url} key={key}>
				{card}
			</Link>
		)
	}

	revealContent = (id, animate) => {
		const div = document.getElementById(id)
		let heights = this.state.heights
		if (div != null)
		{
			let content = div.getElementsByClassName('reveal-on-tap pt-3 pb-5')[0]
			if (heights[id] === undefined)
			{
				const clone = content.cloneNode(true)
				clone.style.cssText = "position: fixed; top -9999px; opacity: 0"
				document.body.appendChild(clone)
				let height = clone.offsetHeight
				clone.parentNode.removeChild(clone)
				height *= 2
				heights[id] = height + "px"
			}
			if (content.style.maxHeight === heights[id])
			{
				content.style.transition = "max-height 0.4s ease, padding-bottom 0.4s ease"
				content.style.paddingBottom = 0
				content.style.maxHeight = 0
				heights = heights.filter((_, index) => index !== id) //Pour vider le tableau des sections fermées
			}
			else
			{
				content.style.transition = (animate === false) ? "none" : "max-height 0.8s ease, padding-bottom 0.8s ease"
				content.style.paddingBottom = "20px"
				content.style.maxHeight = heights[id]
			}
			this.setState({ heights : heights })
		}
	}

	printSection = (title, html, icon, phone, email, website, localisation, facebook, instagram, key) => {
		let jsx = null
		let pictoJSX = null
		let titleJSX = null
		let iconDoc = null
		const icons = this.props.icons
		const theme = this.props.theme
		for (let i = 0; i < icons.length; i++)
		{
			if (icons[i]._id === icon)
			{
				iconDoc = icons[i]
				break
			}
		}
		const chevronDown = <ChevronDownIcon className="h-6 w-6 flex-shrink-0"/>
		const chevronUp = <ChevronUpIcon className="h-6 w-6 flex-shrink-0"/>
		const single = (this.state.page && this.state.page.sections && this.state.page.sections.length === 1)
		if (title !== null)
		{
			const alt = "picto " + title
			pictoJSX = (iconDoc !== null) ? <ThemeIcon icon={iconDoc} type="fill" color={'#' + theme.color1} legacyTheme={theme._id} alt={alt} className="w-6 float-left mr-3" /> : null
			titleJSX = 
				<div className="flex justify-between space-x-2 items-start mb-3">
					<p className="font-semibold flex-grow">{title}</p>
					{single ? null : (this.state.heights[key] ? chevronDown : chevronUp)}
				</div>
			jsx = (
				<div className="page bg-white rounded-xl pt-7 px-6 m-5 min-h-20 text-base filter drop-shadow-sm" id={key} key={key} onClick={(single) ? undefined : this.revealContent.bind(this, key)}>
					{pictoJSX} {titleJSX}
					<SectionActions phone={phone} email={email} website={website} localisation={localisation} facebook={facebook} instagram={instagram} labels={this.props.lang_assets.section_actions} color={'#' + theme.color1} />
					<div className={(single) ? "wysiwyg pt-3 pb-5" : "reveal-on-tap wysiwyg pt-3 pb-5"} dangerouslySetInnerHTML={{ __html: html }}></div>
				</div>
			)
		}
		else
		{
			jsx = (
				<div className="page bg-white rounded-xl pt-7 px-6 m-5 min-h-20 text-base filter drop-shadow-sm" id={key} key={key} onClick={(single) ? undefined : this.revealContent.bind(this, key)}>
					<div className={(single) ? "wysiwyg pt-3 pb-5" : "reveal-on-tap wysiwyg pt-3 pb-5"} dangerouslySetInnerHTML={{ __html: html }}></div>
				</div>
			)
		}
		return (jsx)
	}

	render() {
		const category = this.state.category
		const page = this.state.page
		const list = this.state.list
		if (!this.props.match.params.position && this.state.categories && this.props.icons)
		{
			let group_name = ""
			for (let i = 0; i < this.props.group.translations.length; i++)
			{
				if (this.props.group.translations[i].lang === this.props.user.lang)
				{
					group_name = this.props.group.translations[i].name
					break
				}
			}
			const group_categories = this.state.categories.filter(cat => cat.group === this.props.group._id)
			let tile_k = -1
			return (
				<div ref={this.pageRef} className={this._enter_anim}>
					<div className="z-0 w-full fixed top-0 h-44 flex flex-col justify-end px-5 pb-12" style={{ backgroundColor: '#' + this.props.theme.color1 }}>
						<h1 className="text-white text-2xl font-bold">{group_name}</h1>
						<p className="text-white text-sm opacity-80">{this.props.lang_assets.home.categories_count.replace('%d', group_categories.length)}</p>
					</div>
					<div className="z-10 w-full absolute mt-36 pt-8 pb-12 px-5 rounded-3xl bg-white min-h-9/10-screen">
						<div className="grid grid-cols-2 gap-3">
							{group_categories.map(cat => {
								tile_k++
								return this.printRubricTile(cat, tile_k)
							})}
						</div>
					</div>
				</div>
			)
		}
		else if (category && category.type === "list" && list && this.state.pages && this.props.icons)
		{
			let image = (list.cover || list.cover_ext) ? connexion.connect.url + 'webapp/lists/cover?id=' + list._id : null
			if (!image)
				image = picture
			const elements = list.elements
			const colors = this.colors
			let elements_k = -1
			return (
				<div ref={this.pageRef} className={this._enter_anim}>
					<Swipeable onSwiped={this.swiped} onSwipingLeft={this.swipeLeft} onSwipingRight={this.swipeRight}>
						{/* <div className="photoWrap"> */}
						<CoverImage className="overflow-hidden fixed w-full top-0" src={image} alt="banner" />
						{/* <div className="contentWrapper"> */}
						<div className="bg-white w-full pt-8 px-2.5 mt-48 pb-10 min-h-9/10-screen absolute rounded-t-3xl">
							{
								elements.map(({ translations, icon, page }) => {
									let text = ""
									for (let j = 0; j < translations.length; j++)
									{
										if (translations[j].lang === this.props.user.lang)
										{
											text = translations[j].text
											break
										}
									}
									elements_k++
									return this.printContent(elements_k, colors[0], text, icon, page)
								})
							}
						</div>
					</Swipeable>
				</div>
			)
		}
		else if (category && category.type === "page" && page && this.props.icons)
		{
			let image = (page.cover || page.cover_ext) ? connexion.connect.url + 'webapp/pages/cover?id=' + page._id : null
			if (!image)
				image = picture
			let imageJSX = null
			if (image)
			{
				imageJSX = (
					// <div className="photoWrap">
					<CoverImage className="overflow-hidden fixed w-full top-0" src={image} alt="banner" />
				)
			}
			const sections = page.sections
			let section_k = -1
			let service = null
			if (page.service)
			{
				let title = ""
				for (let j = 0; j < page.service.translations.length; j++)
				{
					if (page.service.translations[j].lang === this.props.user.lang)
					{
						title = page.service.translations[j].title
						break
					}
				}
				const styles = { backgroundColor: '#' + this.props.theme.color1, borderColor: '#' + this.props.theme.color1 }
				if (this.state.service)
				{
					let url = ""
					for (let i = 0; i < this.state.service.translations.length; i++)
					{
						if (this.state.service.translations[i].lang === this.props.user.lang)
						{
							url = this.state.service.translations[i].url
							break
						}
					}
					if (!url) {
						for (let i = 0; i < this.state.service.translations.length; i++) {
							if (this.state.service.translations[i].url) {
								url = this.state.service.translations[i].url
								break
							}
						}
					}
					if (url) {
						url = this.props.lang_assets.paths.services + "/" + url
						service = (<Link to={url}><button type="button" className="service-cta-btn" style={styles}>{title}</button></Link>)
					}
				}
				else if (page.service.service === "precheckin")
					service = (<Link to="/precheckin"><button type="button" className="service-cta-btn" style={styles}>{title}</button></Link>)
				else if (page.service.link)
					service = (<a href={page.service.link}><button type="button" className="service-cta-btn" style={styles}>{title}</button></a>)
			}
			return (
				<div ref={this.pageRef} className={this._enter_anim}>
					<Swipeable onSwiped={this.swiped} onSwipingLeft={this.swipeLeft} onSwipingRight={this.swipeRight}>
						{imageJSX}
						{/* <div className="min-h-4/5-screen w-full top-1/4 absolute rounded-t-3xl"> */}
						<div className={`contentWrapper bg-gray-100${service ? ' has-sticky-cta' : ''}`}>
							{
								sections.map(({ translations, icon, phone, email, website, localisation, facebook, instagram }) => {
									let title = ""
									let html = ""
									for (let j = 0; j < translations.length; j++)
									{
										if (translations[j].lang === this.props.user.lang)
										{
											title = translations[j].title
											html = translations[j].html
											break
										}
									}
									section_k++
									let ret = this.printSection(title, html, icon, phone, email, website, localisation, facebook, instagram, section_k)
									return (ret)
								})
							}
						</div>
						{service && <div className="sticky-cta-bar">{service}</div>}
					</Swipeable>
				</div>
			)
		}
		else
		{
			return (
				<div ref={this.pageRef} className={this._enter_anim}>
					<Skeleton variant="page" />
				</div>
			)
		}
	}
}

export default Categories
